/** In this file entities are declared */
import { BACKOFFICE_MANAGER_URL } from "../../request";
import ModuleTranslations from "./ModuleTranslations";
import { getTranslatedDefinition } from "../utils";
import globalMessages from "../../intl/globalMessages";
import { FormattedMessage } from "react-intl";
import React from "react";

const ModuleDefinition = {
  /** name is the title */
  name: "Forms",
  /** entityName is used to link with the constants */
  entityName: "questionnaire",
  restConfig: {
    baseURL: `${BACKOFFICE_MANAGER_URL}`,
    create: {
      url: ({ propertyTicker }) => `/v1/${propertyTicker}/questionnaires`,
      method: "post",
      resetCache: true,
      headers: ({ propertyTicker }) => ({ "x-property": propertyTicker }),
    },
    update: {
      url: ({ propertyTicker }) => `/v1/${propertyTicker}/questionnaires`,
      method: "put",
      resetCache: true,
      headers: ({ propertyTicker }) => ({ "x-property": propertyTicker }),
    },
    fetch: {
      url: ({ propertyTicker, ticker }) =>
        `/v1/${propertyTicker}/questionnaires${ticker ? `/${ticker}` : ""}`,
      method: "get",
      headers: ({ propertyTicker }) => ({ "x-property": propertyTicker }),
    },
    delete: {
      url: ({ propertyTicker, id }) => `/v1/${propertyTicker}/questionnaires/${id}`,
      method: "delete",
      resetCache: true,
      headers: ({ propertyTicker }) => ({ "x-property": propertyTicker }),
    },
    reorder: {
      url: ({ propertyTicker, id, afterId }) =>
        `/v1/${propertyTicker}/questionnaires/${id}/reorder` +
        (afterId ? `?afterId=${encodeURIComponent(afterId)}` : ""),
      method: "put",
      resetCache: true,
      // No body, so axios defaults PUT to x-www-form-urlencoded; BM (Micronaut) only accepts json.
      headers: ({ propertyTicker }) => ({
        "x-property": propertyTicker,
        "Content-Type": "application/json",
      }),
    },
  },
  renderers: {
    list: {},
    form: {},
  }, //render functions by attribute name, this overrides default widgets specified in the fields section
  translation: {
    translated: true,
    fieldName: "translations",
    displayName: "Translations",
    widget: "translations",
    entityProperty: "translations",
  },
  sorting: null,
  reorder: true,
  fields: {
    /** Here are te entities used in the lists, Order is important */
    /** fieldName: this is used like the id container of the properties */
    /** displayName: this is the title rendered */
    list: [
      {
        fieldName: "active",
        widget: "singleSwitch",
        toggleAction: true,
        displayName: "Active",
      },
      {
        fieldName: "ticker",
        displayName: "Ticker",
      },
      {
        fieldName: "dependers",
        widget: "arrayPropertyRenderer",
        searchCriteria: "type",
        fieldSelector: {
          EXTRA: "Extra",
          GUEST_FORM: "Guest Form",
          CANCELLATION_FORM: "Cancellation Popup",
          ROOMSTAY_CHECKOUT: "Check-out form",
        },
        displayName: "Enable for",
      },
    ],
    /** Here is the entity used in the forms, Order is important */
    /** all the properties can be found in app/components/CRUD/Common, at the corresponding js file */
    /** fieldName: is like the id in html, it must be unique among the attributes */
    /** widget: is used to render the kind of interaction the user will have, a complete list can be found in component/CRUD/Common */
    /** displayName: The text that introduces the widget */
    /** defaultValue: The default value of the widget */
    /** optionDisplay: An object that containes objects with the option at the select */
    form: [
      {
        fieldName: "id",
        widget: "hidden",
      },
      {
        fieldName: "propertyTicker",
        widget: "hidden",
      },
      {
        fieldName: "active",
        displayName: "Active",
        widget: "singleSwitch",
        className: "activeCheckbox",
      },
      {
        fieldName: "ticker",
        displayName: "Form Ticker",
        widget: "input",
        className: "tickerInput",
      },
      {
        fieldName: "dependers",
        displayName: "Enable for:",
        widget: "selector",
        optionDisplay: {
          EXTRA: {
            label: "Extras",
          },
          GUEST_FORM: {
            label: "Guest form",
          },
          CANCELLATION_FORM: {
            label: "Cancellation popup",
          },
          ROOMSTAY_CHECKOUT: {
            label: "Check-out: RoomStay",
          },
        },
        defaultValue: "EXTRA",
      },
      {
        fieldName: "dependersBoxes",
        widget: "multicheckbox",
        selectables: true,
        selectAllText: "Select all",
        selectNoneText: "Select none",
        visible: ({ formValues }) => {
          return formValues.dependers === "EXTRA";
        },
      },
      {
        /** In nested entities the fieldName must be used in the form so it knows which entities must be declared respectively. No need to put in the router the components*/
        fieldName: "fields",
        displayName: "Constraints",
        introductionText: "introduction text",
        widget: "nestedEntity",
        nested: true,
        entityName: "CancellationPolicyConfiguration",
        nestedTitle: "Edit",
        sortName: "position",
        defaultValue: [],
      },
    ],
  },
  validation: {
    ticker: {
      type: "String",
      constraints: {
        presence: {
          allowEmpty: false,
        },
      },
    },
    dependers: {
      type: "Enum",
      constraints: {
        inclusion: {
          within: ["EXTRA", "GUEST_FORM", "CANCELLATION_FORM", "ROOMSTAY_CHECKOUT"],
        },
        presence: {
          allowEmpty: false,
        },
      },
      defaultValue: "EXTRA",
    },
    fields: {
      type: "Arr",
      constraints: {
        length: {
          minimum: 1,
          message: <FormattedMessage {...globalMessages.requireAtLeastOneRestriction} />,
        },
      },
    },
  },
};

export default ({ locale }) =>
  getTranslatedDefinition({ ModuleDefinition, ModuleTranslations, locale });
